import React, { useEffect, useState } from 'react'
import { Create, SaveButton, TabbedForm, Toolbar, useDataProvider } from 'react-admin'
import Permission from '../../components/Permission'
import { PERMISSIONS } from '../../constants'
import { getChainId } from '../../lib'
import { ProductTab, RedeemTab, transformMoneyProduct } from './MoneyProductsForm'

const CreateToolbar = (props: any) => (
  <Toolbar {...props}>
    <SaveButton />
  </Toolbar>
)

const create = ({ ...props }) => {
  const dataProvider = useDataProvider()
  const [places, setPlaces] = useState<Array<{ id: string; name: string }>>([])

  useEffect(() => {
    dataProvider
      .getList(`chains/${getChainId()}/places`, { filter: {}, sort: { field: 'name', order: 'ASC' } })
      .then(({ data }) => setPlaces(data as Array<{ id: string; name: string }>))
  }, [])

  return (
    <Permission permission={PERMISSIONS.CREATE_PRODUCT}>
      <Create {...props} title="Cadastrar produto em dinheiro" transform={transformMoneyProduct}>
        <TabbedForm toolbar={<CreateToolbar />} sanitizeEmptyValues>
          {ProductTab()}
          {RedeemTab({ places })}
        </TabbedForm>
      </Create>
    </Permission>
  )
}

export default create
